import React, { createContext, useContext, useState } from 'react';
import { MdBlock } from 'react-icons/md';

// Create the context
const ForbiddenDialogContext = createContext();

// ForbiddenDialog component
const ForbiddenDialog = ({ title, message, isOpen, setIsOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="p-6 bg-red-100 text-red-800 rounded-lg shadow-xl border border-red-500 max-w-md w-full">
        <div className="flex items-center mb-4">
          <MdBlock className="h-8 w-8 text-red-600 mr-2" />
          <h2 className="text-xl font-bold">{title}</h2>
        </div>
        <p className="text-lg font-medium mb-4">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={() => setIsOpen(false)}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

// Provider component
export const ForbiddenDialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    isOpen: false,
    title: '',
    message: '',
  });

  const showForbiddenDialog = ({ title, message }) => {
    setDialogState({ isOpen: true, title, message });
  };

  const hideForbiddenDialog = () => {
    setDialogState({ isOpen: false, title: '', message: '' });
  };

  return (
    <ForbiddenDialogContext.Provider value={{ showForbiddenDialog, hideForbiddenDialog }}>
      {children}
      <ForbiddenDialog
        title={dialogState.title}
        message={dialogState.message}
        isOpen={dialogState.isOpen}
        setIsOpen={hideForbiddenDialog}
      />
    </ForbiddenDialogContext.Provider>
  );
};

// Hook to use the context
export const useForbiddenDialog = () => {
  const context = useContext(ForbiddenDialogContext);
  if (!context) {
    throw new Error('useForbiddenDialog must be used within a ForbiddenDialogProvider');
  }
  return context;
};